export default __webpack_public_path__ + "locales/sq-AL/FormFillingTipsDialog.json?hash=176cb700fba39209c81c14635f0b50b1";